import React from 'react';
import {
  ScatterChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
  ZAxis,
  Scatter,
  Tooltip,
  Legend,
  CartesianGrid,
  Cell,
} from 'recharts';
import { darken, lighten } from '@mui/material';

export const ScatterChartSimple = (props) => {
  const { data, locale } = props;

  const main = data.filter((d) => d.isMain === true);
  const bench = data.filter((d) => d.isBench === true);
  const vg = data.filter((d) => d.isVlaamsGewest === true);

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const value =
        data[0] && data[0].d3format
          ? locale.format(data[0].d3format)(payload[0].value)
          : payload[0].value;

      return (
        <div
          style={{
            fontSize: '14px',
            background: '#fff',
            border: '1px solid black',
            padding: '8px',
          }}
        >
          <p>
            <span
              style={{ fontWeight: 'bold' }}
            >{`${payload[0].payload.ruimte}:`}</span>{' '}
            {`${value}`}
          </p>
        </div>
      );
    }

    return null;
  };

  return (
    <ResponsiveContainer width="100%" height="100%">
      <ScatterChart
        margin={{
          top: 0,
          right: 64,
          left: 0,
          bottom: 40,
        }}
      >
        {/* <CartesianGrid strokeDasharray="3 3" /> */}
        <XAxis
          type="number"
          dataKey="value"
          name="waarde"
          domain={['dataMin', 'dataMax']}
          tickCount={3}
          tick={{ fontSize: '0.8em', paddingTop: '16px' }}
          tickFormatter={(d, i) => {
            return data[0] && data[0].d3format
              ? locale.format(data[0].d3format)(d)
              : d;
          }}
          tickMargin={12}
        />
        <YAxis
          type="number"
          dataKey="y"
          tick={false}
          tickLine={false}
          axisLine={false}
          height={10}
          width={60}
        />
        <ZAxis range={[0, 200]} dataKey="z" />
        <Tooltip
          cursor={{ strokeDasharray: '3 3' }}
          content={<CustomTooltip />}
          // formatter={(value) =>
          //   data[0] && data[0].d3format
          //     ? locale.format(data[0].d3format)(value)
          //     : value
          // }
        />
        <Scatter
          name="Spreiding"
          data={data}
          fillOpacity={0.1}
          strokeOpacity={0.1}
        >
          {data.map((d, i) => {
            return <Cell stroke={d.color} fill={d.color}></Cell>;
          })}
        </Scatter>
        <Scatter
          name={'Spreiding_VG'}
          data={vg}
          fillOpacity={1}
          strokeOpacity={1}
        >
          {vg.map((d, i) => {
            return <Cell stroke={'#fff'} fill={d.color}></Cell>;
          })}
        </Scatter>
        <Scatter
          name={'Spreiding_Bench'}
          data={bench}
          fillOpacity={1}
          strokeOpacity={1}
        >
          {bench.map((d, i) => {
            return <Cell stroke={'#fff'} fill={d.color}></Cell>;
          })}
        </Scatter>
        <Scatter
          name="Spreiding_Main"
          data={main}
          fillOpacity={1}
          strokeOpacity={1}
        >
          {main.map((d, i) => {
            return <Cell stroke={'#fff'} fill={d.color}></Cell>;
          })}
        </Scatter>
      </ScatterChart>
    </ResponsiveContainer>
  );
};

export const ScatterChartSimpleMobile = (props) => {
  const { data, locale } = props;

  const main = data.filter((d) => d.isMain === true);
  const bench = data.filter((d) => d.isBench === true);
  const vg = data.filter((d) => d.isVlaamsGewest === true);

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const value =
        data[0] && data[0].d3format
          ? locale.format(data[0].d3format)(payload[0].value)
          : payload[0].value;

      return (
        <div
          style={{
            fontSize: '11px',
            background: '#fff',
            border: '1px solid black',
            padding: '8px',
          }}
        >
          <p>
            <span
              style={{ fontWeight: 'bold' }}
            >{`${payload[0].payload.ruimte}:`}</span>{' '}
            {`${value}`}
          </p>
        </div>
      );
    }

    return null;
  };

  return (
    <ResponsiveContainer width="100%" height="100%">
      <ScatterChart
        margin={{
          top: 0,
          right: 20,
          left: 0,
          bottom: 30,
        }}
      >
        {/* <CartesianGrid strokeDasharray="3 3" /> */}
        <XAxis
          type="number"
          dataKey="value"
          name="waarde"
          domain={['dataMin', 'dataMax']}
          tickCount={3}
          tick={{ fontSize: '11px', paddingTop: '16px' }}
          tickFormatter={(d, i) => {
            return data[0] && data[0].d3format
              ? locale.format(data[0].d3format)(d)
              : d;
          }}
          tickMargin={12}
        />
        <YAxis
          type="number"
          dataKey="y"
          tick={false}
          tickLine={false}
          axisLine={false}
          height={10}
          width={20}
        />
        <ZAxis range={[0, 200]} dataKey="z" />
        <Tooltip
          cursor={{ strokeDasharray: '3 3' }}
          content={<CustomTooltip />}
          // formatter={(value) =>
          //   data[0] && data[0].d3format
          //     ? locale.format(data[0].d3format)(value)
          //     : value
          // }
        />
        <Scatter
          name="Spreiding"
          data={data}
          fillOpacity={0.1}
          strokeOpacity={0.1}
        >
          {data.map((d, i) => {
            return <Cell stroke={d.color} fill={d.color}></Cell>;
          })}
        </Scatter>
        <Scatter
          name={'Spreiding_VG'}
          data={vg}
          fillOpacity={1}
          strokeOpacity={1}
        >
          {vg.map((d, i) => {
            return <Cell stroke={'#fff'} fill={d.color}></Cell>;
          })}
        </Scatter>
        <Scatter
          name={'Spreiding_Bench'}
          data={bench}
          fillOpacity={1}
          strokeOpacity={1}
        >
          {bench.map((d, i) => {
            return <Cell stroke={'#fff'} fill={d.color}></Cell>;
          })}
        </Scatter>
        <Scatter
          name="Spreiding_Main"
          data={main}
          fillOpacity={1}
          strokeOpacity={1}
        >
          {main.map((d, i) => {
            return <Cell stroke={'#fff'} fill={d.color}></Cell>;
          })}
        </Scatter>
      </ScatterChart>
    </ResponsiveContainer>
  );
};
